export const en = {
    date_placeholder: 'dd.mm.yyyy',
    trip_does_not_exist: 'This trip does not exist',
    value_error: 'Invalid field value',
    gender: 'Gender',
    choose_document: 'Choose document',
    add_document: 'Add document',
};
